import $ from 'jquery';
import Handlebars from 'handlebars';
import tdaConfig from 'lib/util/tda.config';
import cookies from 'utils/cookies';
import txtTemplate from './dealer.panel.hbs';
import zip from 'lib/util/zip';
import batws from 'lib/services/batws';
import Paginator from 'lib/paginator';
import xformDealersCommon from 'lib/transforms/dealer.tmpl.common';
import 'lib/helpers/ifCond';

var __tmplDealers = Handlebars.compile(txtTemplate);
// NOT TO be confused with the SLP thank-you page dealer!!
// see features/slp/thank-you for that.

function __dealerQuery(opts) {
  var paginatorOpts = {
    query: {},
    dataField: 'dealerLocator',
    countField: 'dealerCount',
    xform: xformDealersCommon,
    pageSize: 5
  };
  return $.extend(paginatorOpts, opts);
}

// Set mode and mode filters should all be moved out to shared file,
// we use it alot
var __identityFilter = function () {
  return true;
};

var __pmaFilter = function (dealer) {
  return dealer.isPma;
};

var __nonPmaFilter = function (dealer) {
  return !dealer.isPma;
};

var __miraiOnly = function (dealer) {
  return dealer.isMirai;
};

var dealerPanel = {
  load: function (el, config) {
    if (cookies.getItem('isConfirmedZip') !== 'true') {
      // In the very distant past, we used to show a dealer search panel if zip wasn't
      // confirmed. That has been broken for some time now, so we will continue doing nothing :)
      return;
    }
    this.$el = $(el);
    this.config = config;
    this.setMode('pma');
    this.beginSearch();
  },

  setMode: function (mode) {
    this.mode = mode;
    if (mode === 'pma') {
      this.filter = __pmaFilter;
    } else if (mode === 'mirai') {
      this.filter = __miraiOnly;
    } else if (mode === 'nonPma') {
      this.filter = __nonPmaFilter;
    } else {
      this.filter = __identityFilter;
    }
  },

  beginSearch: function () {
    var query = __dealerQuery({
      query: { zipcode: zip.getCookiedDefaultFallback() }
    });
    this.paginator = new Paginator(batws.geo().search, query);
    this.paginator.next()
      .then(res => this.showResults(res))
      .catch(err => console.error('Err in dealer search: ', err)); // eslint-disable-line no-console
  },

  showResults: function (dealerData) {
    var ctx = {
      i18n: this.config.i18n,
      dealer: dealerData.records.filter(this.filter),
      markerConfig: 'scale:2|shadow:false|icon:http://www.buyatoyota.com/assets/img/maps/marker@2x.png',
      contextUrl: `/${tdaConfig.site.context_url}`, // dont need to use GOTO URLS, since only uses confirmed zip
    };
    this.$el.html(__tmplDealers(ctx));
  },
};

export default dealerPanel;
